<template>
<v-container fluid grid-list-lg class="ma-0 pa-0">
<v-layout row wrap>
  <v-flex xs12 class="mb-2"><h1>Settings</h1></v-flex>

  <v-flex xs12>

    <v-tabs
      v-model="ui.tab"
      grow
      :slider-color="!isDark ? 'primary' : 'grey lighten-5'"
      class="elevation-4"
    >
      <v-tab ripple :style="{'background': isDark && ui.tab === 0 ? '#212121!important' : !isDark && ui.tab === 0 ? '#E0E0E0!important' : 'transparent'}">Products</v-tab>
      <v-tab ripple :style="{'background': isDark && ui.tab === 1 ? '#212121!important' : !isDark && ui.tab === 1 ? '#E0E0E0!important' : 'transparent'}">Shipping</v-tab>
      <v-tab ripple :style="{'background': isDark && ui.tab === 2 ? '#212121!important' : !isDark && ui.tab === 2 ? '#E0E0E0!important' : 'transparent'}">Printing</v-tab>

      <v-tab-item>
        <v-flex xs12 sm12 class="pa-0 mt-0">
            <v-card class="elevation-0">
            <v-card-title>
                <h3 class="mt-2">Product Inventory Location</h3>
            </v-card-title>
            <v-card-text>
                <v-select
                    v-if="!ui.loading && inventory_locations.length > 0"
                    v-model="settings.inventory_location"
                    :items="inventory_locations"
                    item-text="id"
                    return-object
                    box
                    label="Inventory Location"
                    @change="updateInventoryLocation()"
                    hide-details
                    class="mb-0 pb-0"
                >
                </v-select>

                <div v-if="!ui.loading && settings.inventory_location">
                <v-flex xs12 class="pl-0 pr-0 mt-3 pt-0 pb-1"><v-text-field label="Name" :value="settings.inventory_location.name" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="Address 1" :value="settings.inventory_location.address1" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="Address 2" :value="settings.inventory_location.address2" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="City" :value="settings.inventory_location.city" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="Zip" :value="settings.inventory_location.zip" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="State" :value="settings.inventory_location.province" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="Country" :value="settings.inventory_location.country" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="Phone" :value="settings.inventory_location.phone" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                <v-flex xs12 class="pl-0 pr-0 pt-0 pb-1"><v-text-field label="Active" :value="settings.inventory_location.active" readonly box hide-details class="mt-0 mb-0 pt-0"></v-text-field></v-flex>
                </div>

                <v-progress-linear
                v-if="inventory_locations.length === 0"
                class="text-xs-center pa-0 mb-0"
                :color="isDark ? 'white' : 'primary'"
                indeterminate
                ></v-progress-linear>
            </v-card-text>
            </v-card>
        </v-flex>
      </v-tab-item>

      <v-tab-item>
        <v-flex xs12 sm12 class="pa-0 mt-0">
        <v-card class="elevation-0">
        <v-card-title class="pb-0">
            <h3 class="mt-2">Shipping Boxes</h3>

            <v-flex xs12 class="mt-4 mb-0 pb-0 ml-0 mr-0 pl-0 pr-0 pt-0">
                <v-btn @click="showShipmentBox('new')" large block>new shipping box</v-btn>
            </v-flex>
        </v-card-title>
        <v-card-text class="pb-1 shipment-box-container">
            <div v-if="!ui.loading && settings.shipment_boxes" class="mt-0 mb-2 pb-1" style="height:100%;">

                <v-data-iterator
                    :items="settings.shipment_boxes"
                    :total-items="settings.shipment_boxes.length"
                    no-data-text="There are no shipment boxes defined yet."
                    content-tag="v-layout"
                    hide-actions
                    row
                    wrap
                    >
                    <v-flex
                        slot="item"
                        slot-scope="props"
                        xs12
                        sm3
                        class="mt-0"
                        @click="showShipmentBox(props.item)"
                    >
                        <v-hover>
                        <v-card
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 10 : 2}`"
                            class="pointer"
                        >
                        <v-card-title class="white--text elevation-4" :class="{'primary': !isDark, 'grey darken-4': isDark}"><h4>{{ props.item.name | capitalize }}</h4></v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                            <v-list-tile>
                            <v-list-tile-content>Default:</v-list-tile-content>
                            <v-list-tile-content class="align-end"><v-icon v-if="props.item.default">check</v-icon><v-icon v-else>close</v-icon></v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                            <v-list-tile-content>Service:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.service.type }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                            <v-list-tile-content>Height:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.height }} in</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                            <v-list-tile-content>Width:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.width }} in</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                            <v-list-tile-content>Length:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.length }} in</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                            <v-list-tile-content>Weight:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ props.item.weight }} in</v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions class="pb-0 pl-0 pr-0"> 
                            <v-btn block @click.prevent.stop="deleteShipmentBox(props.item)" class="elevation-0">delete</v-btn>
                        </v-card-actions>
                        </v-card>
                        </v-hover>
                    </v-flex>
                    </v-data-iterator>

            </div>

            <v-progress-linear
            v-if="inventory_locations.length === 0"
            class="text-xs-center pl-0 pr-0 pt-0 pb-2 mb-2"
            :color="isDark ? 'white' : 'primary'"
            indeterminate
            ></v-progress-linear>
        </v-card-text>
        </v-card>
        </v-flex>
      </v-tab-item>

      <v-tab-item>
        <v-flex xs12 sm12 class="pa-0 mt-0">
            <v-card class="elevation-0">
            <v-card-title>
                <h3 class="mt-2">Printers</h3>
            </v-card-title>
            <v-card-text>


                <div v-if="!ui.loading && printers">
                    <v-select
                        v-if="!ui.loading"
                        v-model="settings.printers.labels"
                        :items="printers"
                        @change="updatePrinterSettings()"
                        item-text="name"
                        return-object
                        box
                        label="Label Printer"
                        hide-details
                        class="mb-0 pb-0"
                    >
                    </v-select>

                    <v-select
                        v-if="!ui.loading"
                        v-model="settings.printers.packing_slips"
                        :items="printers"
                        @change="updatePrinterSettings()"
                        item-text="name"
                        return-object
                        box
                        label="Packing Slip Printer"
                        hide-details
                        class="mb-0 pb-0 mt-1"
                    >
                    </v-select>
                </div>

                <v-progress-linear
                v-if="printers.length === 0"
                class="text-xs-center pa-0 mb-0"
                :color="isDark ? 'white' : 'primary'"
                indeterminate
                ></v-progress-linear>
            </v-card-text>
            </v-card>
        </v-flex>

          <v-flex xs12 v-if="prettyPackingSlip" class="pa-0 mt-0">
            <v-card class="elevation-0">
                <v-card-title>
                    <h3 class="mt-2">Packing Slip Template</h3>
                </v-card-title>
                <v-card-text>
                    <codemirror v-model="prettyPackingSlip" :options="cmOptions"></codemirror>
                </v-card-text>
                <v-card-actions>
                    <v-btn block large @click="savePackingSlip" :loading="ui.saving">save template</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
      </v-tab-item>
    </v-tabs>

  </v-flex>


<v-dialog
    v-model="ui.shipment_box"
    width="500"
>
    <v-card>
        <v-toolbar :class="{'primary white--text': !isDark}">
            <v-toolbar-title>Shipment Box</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
            <v-layout row wrap>
                    <v-flex xs12 class="pl-0 pr-0 mt-3 pt-0 pb-1">
                        <v-text-field label="Name" v-model="current_shipment_box.name" :rules="[ui.rules.required]" box hide-details class="mt-0 mb-0 pt-0"></v-text-field>
                    </v-flex>

                    <v-checkbox 
                    v-model="current_shipment_box.default"
                    :disabled="current_shipment_box.default"
                    label="Is this the default box that's being used for shipments?"
                    >
                    </v-checkbox>

                    <v-select
                        v-if="!ui.loading"
                        v-model="current_shipment_box.service"
                        :items="default_shipment_services"
                        item-text="type"
                        return-object
                        box
                        label="Service"
                        hide-details
                        class="mb-0 pb-0"
                    >
                    </v-select>

                    <v-flex xs12 sm3><v-text-field label="Box Height" v-model.number="current_shipment_box.height" suffix="in" box hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm3><v-text-field label="Box Width"  v-model.number="current_shipment_box.width" suffix="in" box hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm3><v-text-field label="Box Length" v-model.number="current_shipment_box.length" suffix="in" box hide-details></v-text-field></v-flex>
                    <v-flex xs12 sm3><v-text-field label="Box Weight" v-model.number="current_shipment_box.weight" suffix="oz" box hide-details></v-text-field></v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions class="pb-0 pl-0 pr-0">
            <v-btn @click="saveShipmentBox" block large class="elevation-0" :class="{'primary white--text': !isDark}">save box</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>


</v-layout>
</v-container>
</template>

<script>
import { db, functions } from '@/services/firebase.js'
import { isEqual, clone } from 'lodash'
import { codemirror } from 'vue-codemirror'
// require styles
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/seti.css'
const beautify = require('vue-beautify')

export default {
    components: {codemirror},
    data () {
        return {
            cmOptions: {
                tabSize: 4,
                mode: 'text/html',
                theme: 'seti',
                lineNumbers: true,
                lineWrapping: true,
                line: true
            },
            ui: {
                tab: null,
                loading: true,
                shipment_box: false,
                saving: false,
                rules: {
                    required: value => !!value || 'Required.'
                }
            },
            printers: [],
            inventory_locations: [],
            packing_slip: null,
            default_shipment_services: [{type: 'USPS Priority Mail', code: 'usps_priority_mail'}, {type: 'USPS First Class Mail', code: 'usps_first_class_mail'}],
            default_shipment_box: {name: '', default: false, service: {type: 'USPS First Class Mail', code: 'usps_first_class_mail'}, length: 1, width: 1, height: 1, weight: 1},
            current_shipment_box: {name: '', default: false, service: {type: 'USPS First Class Mail', code: 'usps_first_class_mail'}, length: 1, width: 1, height: 1, weight: 1},
            shipment_boxes: [],
            settings: {
              inventory_location: null,
              shipment_boxes: null,
              packing_slip: null,
              printers: null
            }
        }
    },
    filters: {
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        isDark: function () {
            return this.$vuetify.dark
        },
        prettyPackingSlip: {
            get: function () {
                var self = this

                if (self.packing_slip) {
                    return beautify(self.packing_slip, {"intent_scripts": "keep"})
                } else {
                    return null
                }
            },
            set: function (updated_packing_slip) {
                var self = this
                self.packing_slip = updated_packing_slip
            }
        }
    },
    methods: {
      getPrinters: function () {
        var self = this
        self.ui.loading = true
        var getPrinters = functions.httpsCallable('getPrinters')
        getPrinters()
        .then((printers) => {
            console.log(printers)
            var printer_list = []
            printers.data.forEach((printer) => {
                printer_list.push({id: printer.id, name: printer.name, description: printer.description})
            })
            self.printers = printer_list
            self.ui.loading = false
        })
        .catch((err) => {
            console.error(err)
            self.ui.loading = false
        })
      },
      updatePrinterSettings: function () {
        var self = this
        db.collection('settings').doc('shipments').set({printers: self.settings.printers}, {merge: true})
      },
      getInventoryLocations: function () {
        var self = this
        self.ui.loading = true
        var getProductInventoryLocations = functions.httpsCallable('getProductInventoryLocations')
        getProductInventoryLocations()
        .then((inventory_locations) => {
            //console.log(inventory_locations)
            self.inventory_locations = inventory_locations.data
            self.ui.loading = false
        })
        .catch((err) => {
            console.error(err)
            self.ui.loading = false
        })
      },
      updateInventoryLocation: function () {
        var self = this
        db.collection('settings').doc('shipments').set({inventory_location: self.settings.inventory_location}, {merge: true})
      },
      updateShipmentBoxes: function () {
        var self = this
        db.collection('settings').doc('shipments').set({shipment_boxes: self.settings.shipment_boxes}, {merge: true})
      },
      showShipmentBox: function (shipment_box) {
          var self = this
          if (shipment_box === 'new') {
              self.current_shipment_box = clone(self.default_shipment_box, true)
              self.ui.editing_shipment_box = false
          } else {
            self.current_shipment_box = shipment_box
            self.ui.editing_shipment_box = true
          }
          self.ui.shipment_box = true
      },
      saveShipmentBox: function () {
        var self = this

        if (self.current_shipment_box.name !== ''){

            var current_box = null

            if (self.ui.editing_shipment_box) {
                current_box = self.current_shipment_box
            } else {
                current_box = JSON.parse(JSON.stringify(self.current_shipment_box))
            }

            if (!self.settings.shipment_boxes) {
                current_box.default = true
                self.settings.shipment_boxes = [current_box]
                self.ui.shipment_box = false

            } else {

                var shipment_box_index = self.settings.shipment_boxes.findIndex((box) => {
                    return isEqual(box, current_box)
                })
                
                if (current_box.default) {
                    self.settings.shipment_boxes.forEach((box, i) => {
                        if(!isEqual(box, current_box)){
                            self.settings.shipment_boxes[i].default = false
                        }
                    })
                }

                if (shipment_box_index !== -1) {
                    self.settings.shipment_boxes[shipment_box_index] = current_box
                } else {
                    self.settings.shipment_boxes.push(current_box)
                }

                self.ui.shipment_box = false
            }
            self.updateShipmentBoxes()
        }
      },
      deleteShipmentBox: function (shipment_box) {
          var self = this

          if (!shipment_box.default) {
              var shipment_box_index = self.settings.shipment_boxes.findIndex((box) => {
                  return isEqual(box, shipment_box)
              })
              self.settings.shipment_boxes.splice(shipment_box_index, 1)
              self.$forceUpdate()

              self.updateShipmentBoxes()
          }
      },
      updateShipmentBoxDefault: function () {
          var self = this

          var current_box = null

          if (self.ui.editing_shipment_box) {
            current_box = self.current_shipment_box
          } else {
            current_box = JSON.parse(JSON.stringify(self.current_shipment_box))
          }

          if (self.ui.editing_shipment_box && current_box.default) {
            self.settings.shipment_boxes.forEach((box, i) => {
                if(!isEqual(box, current_box)){
                    self.settings.shipment_boxes[i].default = false
                }
            })
          }
      },
      savePackingSlipTemplate: function () {
          var self = this
          self.ui.saving = true
          db.collection('settings').doc('shipments').set({packing_slip: self.settings.packing_slip}, {merge: true})
          .then(() => {
              self.ui.saving = false
          })
          .catch((err) => {
              console.error(err)
          })
      },
      getPackingSlip: function () {
        var self = this

        var packingSlipFile = functions.httpsCallable('packingSlipFile')
        packingSlipFile({type: 'get'})
        .then((packing_slip) => {
            if (packing_slip.data.success) {
                self.packing_slip = packing_slip.data.file
            } else {
                self.packing_slip = ''
            }
        })
        .catch((err) => {
            console.error(err)
        })  
      },
      savePackingSlip: function () {
        var self = this
        
        self.ui.saving = true

        var packingSlipFile = functions.httpsCallable('packingSlipFile')
        packingSlipFile({type: 'set', packing_slip: self.packing_slip})
        .then(() => {
            //console.log(packing_slip_url)
            self.ui.saving = false
        })
        .catch((err) => {
            console.error(err)
            self.ui.saving = false
        })  
      }
    },
    created () {
        var self = this
        self.getPrinters()
        self.getInventoryLocations()
        self.getPackingSlip()

        db.collection('settings').doc('shipments').onSnapshot(shipmentSnapshot => {
            let shipment_settings = shipmentSnapshot.data()
            self.settings = shipment_settings
        })
    },
    mounted () {
        
    }
}
</script>
<style lang="stylus" scoped>
.theme--dark-old .v-card
  background #40525B!important
.shipment-box-container
  max-height 580px
  overflow-x hidden
  overflow-y overlay
.theme--dark .main-content::-webkit-scrollbar, .theme--dark .v-card__text::-webkit-scrollbar
  background #212121!important
  width 7px!important
.theme--dark .main-content::-webkit-scrollbar-thumb, .theme--dark .v-card__text::-webkit-scrollbar-thumb
  background #212121!important
  border-radius 0px!important
  width 7px!important
.theme--dark .main-content::-webkit-scrollbar-track-piece, .theme--dark .v-card__text::-webkit-scrollbar-track-piece
  background rgb(48, 48, 48)!important
.theme--light .main-content::-webkit-scrollbar, .theme--light .v-card__text::-webkit-scrollbar
  background #1976d2!important
  width 7px!important
.theme--light .main-content::-webkit-scrollbar-thumb, .theme--light .v-card__text::-webkit-scrollbar-thumb
  background #1976d2!important
  border-radius 0px!important
  width 7px!important
.theme--light .main-content::-webkit-scrollbar-track-piece, .theme--light .v-card__text::-webkit-scrollbar-track-piece
  background #FAFAFA!important
</style>